//colorSlice.js
import { createSlice } from '@reduxjs/toolkit';  
  
export const logoSlice = createSlice({  
  name: 'logo',  
  initialState: {
    value: '', 
  },  
  reducers: {  
    setLogo: (state, action) => {  
      state.value = action.payload;  
    },  
  },  
});  
  
export const { setLogo } = logoSlice.actions;  
  
export default logoSlice.reducer;